import { useState } from "react";
import { MoveHorizontal } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

const STATS = [
  { k: "7", v: "Five-star reviews" },
  { k: "100%", v: "Recommend on Facebook" },
  { k: "15", v: "Towns served" },
  { k: "A–Z", v: "Licensed & insured" },
];

const BeforeAfter = () => {
  const [pos, setPos] = useState(50);
  return (
    <div className="relative aspect-[4/5] w-full select-none overflow-hidden rounded-[28px] sm:aspect-[4/3] lg:aspect-[4/5]" data-testid="before-after">
      <img src="/img/p2.jpg" alt="After: new mulch bed along the house" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src="/img/p1.jpg" alt="Before: bare lawn along the house" className="h-full w-full object-cover" />
      </div>
      <span className="absolute left-4 top-4 rounded-full bg-black/55 px-3 py-1 text-xs font-bold uppercase tracking-widest text-white backdrop-blur">Before</span>
      <span className="absolute right-4 top-4 rounded-full bg-[var(--leaf)] px-3 py-1 text-xs font-bold uppercase tracking-widest text-white">After</span>
      <div className="pointer-events-none absolute inset-y-0 w-[2px] bg-white" style={{ left: `${pos}%` }}>
        <span className="absolute left-1/2 top-1/2 grid h-12 w-12 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-white text-[var(--leaf)] shadow-lg">
          <MoveHorizontal className="h-5 w-5" />
        </span>
      </div>
      <input
        type="range" min="0" max="100" value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Drag to compare before and after"
        data-testid="before-after-slider"
        className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
      />
    </div>
  );
};

export const About = () => (
  <section id="about" data-testid="about-section" className="relative bg-[var(--mist)] py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
      <Reveal>
        <BeforeAfter />
        <p className="mt-4 text-center text-sm text-[var(--muted)]">Drag to see the difference</p>
      </Reveal>
      <Reveal delay={0.1} className="flex flex-col justify-center">
        <Eyebrow>Who we are</Eyebrow>
        <h2 className="mt-5 font-display text-4xl font-black leading-[0.95] sm:text-6xl">
          The extra time <span className="font-serif-i font-normal text-[var(--leaf)]">is the difference.</span>
        </h2>
        <p className="mt-7 text-base leading-relaxed text-[var(--muted)] md:text-lg">
          HF Landscape Solutions is dedicated to upholding an exceptional standard that enhances the natural beauty of every property. We take pride in our attention to detail and the extra time we invest in every aspect of a project.
        </p>
        <p className="mt-4 text-base leading-relaxed text-[var(--muted)] md:text-lg">
          Our expertise ensures your outdoor space will be both beautiful and perfectly suited to your lifestyle.
        </p>
        <dl className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-[var(--leaf)]/15 bg-[var(--leaf)]/15">
          {STATS.map((s) => (
            <div key={s.v} className="bg-white p-5 sm:p-6" data-testid={`stat-${s.k}`}>
              <dt className="font-display text-4xl font-black text-[var(--leaf)]">{s.k}</dt>
              <dd className="mt-1 text-sm font-medium text-[var(--muted)]">{s.v}</dd>
            </div>
          ))}
        </dl>
      </Reveal>
    </div>
  </section>
);
